/* ==========================================================================
   Downshift — Section Interactions
   ds-sections.js
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  // -------------------------------------------------------------------------
  // 0. Shopify theme editor — make all animated elements immediately visible
  //    so sections don't appear blank while editing
  // -------------------------------------------------------------------------

  function revealAll() {
    document.querySelectorAll('.ds-fade-in').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  if (window.Shopify && window.Shopify.designMode) {
    revealAll();
    document.addEventListener('shopify:section:load', revealAll);
    document.addEventListener('shopify:section:reorder', revealAll);
  }

  // -------------------------------------------------------------------------
  // 1. IntersectionObserver — Fade-in on scroll
  //    Targets: [data-ds="fade"] and .ds-fade-in elements
  // -------------------------------------------------------------------------

  (function initFadeIn() {
    var elements = document.querySelectorAll('.ds-fade-in, [data-ds="fade"]');
    if (!elements.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach(function (el) {
      observer.observe(el);
    });
  })();


  // -------------------------------------------------------------------------
  // 2. Marquee ticker — pauses on hover, plays on leave
  //    Targets: [data-ds="marquee"] wrapping a .ds-marquee-track
  // -------------------------------------------------------------------------

  (function initMarquee() {
    var marquees = document.querySelectorAll('[data-ds="marquee"]');
    marquees.forEach(function (wrapper) {
      var track = wrapper.querySelector('.ds-marquee-track');
      if (!track) return;

      // Speed class from data attribute: slow | medium | fast
      var speed = wrapper.dataset.speed;
      if (speed) {
        track.classList.remove('ds-marquee-track--slow', 'ds-marquee-track--medium', 'ds-marquee-track--fast');
        track.classList.add('ds-marquee-track--' + speed);
      }

      wrapper.addEventListener('mouseenter', function () {
        track.style.animationPlayState = 'paused';
      });
      wrapper.addEventListener('mouseleave', function () {
        track.style.animationPlayState = 'running';
      });
    });
  })();


  // -------------------------------------------------------------------------
  // 3. FAQ Accordion
  //    Targets: [data-ds="accordion"] > .ds-accordion__item
  //    Each item has: .ds-accordion__trigger (button) + .ds-accordion__body
  // -------------------------------------------------------------------------

  (function initAccordion() {
    var accordions = document.querySelectorAll('[data-ds="accordion"]');

    accordions.forEach(function (container) {
      var items = container.querySelectorAll('.ds-accordion__item');

      items.forEach(function (item) {
        var trigger = item.querySelector('.ds-accordion__trigger');
        var body    = item.querySelector('.ds-accordion__body');
        if (!trigger || !body) return;

        // Set initial ARIA state
        trigger.setAttribute('aria-expanded', 'false');

        trigger.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');

          // Close all siblings first (single-open behaviour)
          items.forEach(function (sibling) {
            if (sibling !== item) {
              sibling.classList.remove('is-open');
              var sibTrigger = sibling.querySelector('.ds-accordion__trigger');
              if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
            }
          });

          // Toggle current item
          item.classList.toggle('is-open', !isOpen);
          trigger.setAttribute('aria-expanded', String(!isOpen));
        });
      });
    });
  })();


  // -------------------------------------------------------------------------
  // 4. PDP Tab Switcher
  //    Targets: [data-ds="tabs"]
  //    Children: [data-tab-trigger="id"] buttons + [data-tab-panel="id"] panels
  // -------------------------------------------------------------------------

  (function initTabs() {
    var tabContainers = document.querySelectorAll('[data-ds="tabs"]');

    tabContainers.forEach(function (container) {
      var triggers = container.querySelectorAll('[data-tab-trigger]');
      var panels   = container.querySelectorAll('[data-tab-panel]');

      if (!triggers.length || !panels.length) return;

      // Set initial state — activate first tab
      function activateTab(targetId) {
        triggers.forEach(function (btn) {
          var isActive = btn.dataset.tabTrigger === targetId;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', String(isActive));
        });

        panels.forEach(function (panel) {
          var isActive = panel.dataset.tabPanel === targetId;
          panel.classList.toggle('is-active', isActive);
        });
      }

      // Init with first trigger
      var firstId = triggers[0].dataset.tabTrigger;
      activateTab(firstId);

      triggers.forEach(function (btn) {
        btn.addEventListener('click', function () {
          activateTab(btn.dataset.tabTrigger);
        });
      });
    });
  })();


  // -------------------------------------------------------------------------
  // 5. Fullscreen hero — video autoplay + responsive desktop/mobile switching
  //    Targets: .ds-hero-full__video--desktop / --mobile
  // -------------------------------------------------------------------------

  (function initHeroVideo() {

    function isMobile() { return window.innerWidth < 768; }

    function syncVideos() {
      var mobileVids  = document.querySelectorAll('.ds-hero-full__video--mobile');
      var desktopVids = document.querySelectorAll('.ds-hero-full__video--desktop');
      var mobile = isMobile();

      mobileVids.forEach(function (v) {
        if (mobile) {
          v.style.display = 'block';
          if (v.paused) v.play().catch(function () {});
        } else {
          v.style.display = 'none';
          v.pause();
        }
      });

      desktopVids.forEach(function (v) {
        if (!mobile) {
          v.style.display = 'block';
          if (v.paused) v.play().catch(function () {});
        } else {
          v.style.display = 'none';
          v.pause();
        }
      });

      // Nudge single (non-responsive) videos in case autoplay was blocked
      document.querySelectorAll('.ds-hero-full__video:not(.ds-hero-full__video--mobile):not(.ds-hero-full__video--desktop)').forEach(function (v) {
        if (v.paused) v.play().catch(function () {});
      });
    }

    syncVideos();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncVideos, 150);
    });

    // Re-run when editor loads a section
    document.addEventListener('shopify:section:load', syncVideos);
  })();


  // -------------------------------------------------------------------------
  // 6. Sticky Buy Box
  //    Targets: .ds-pdp-sticky-box
  //    Adds .is-sticky once user scrolls past .ds-pdp-hero
  // -------------------------------------------------------------------------

  (function initStickyBuyBox() {
    var hero    = document.querySelector('.ds-pdp-hero');
    var buyBox  = document.querySelector('.ds-pdp-sticky-box');
    if (!hero || !buyBox) return;

    function onScroll() {
      // Only sticky on desktop
      if (window.innerWidth < 1024) return;
      var heroBottom = hero.getBoundingClientRect().bottom;
      buyBox.classList.toggle('is-sticky', heroBottom < 80);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
  })();


  // -------------------------------------------------------------------------
  // 7. Header scroll class
  //    Adds .scrolled to <body> after 80px scroll (for Rise theme header tint)
  // -------------------------------------------------------------------------

  (function initHeaderScroll() {
    function onScroll() {
      document.body.classList.toggle('scrolled', window.scrollY > 80);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load in case page is already scrolled
  })();


  // -------------------------------------------------------------------------
  // 8. Subscribe/Save Toggle (PDP Hero)
  //    Targets: [data-ds="sub-toggle"]
  //    Children: [data-sub-option="onetime"] / [data-sub-option="subscribe"] buttons
  //    Toggles .is-active on buttons and shows/hides price variants
  // -------------------------------------------------------------------------

  (function initSubToggle() {
    var toggles = document.querySelectorAll('[data-ds="sub-toggle"]');

    toggles.forEach(function (container) {
      var options = container.querySelectorAll('[data-sub-option]');

      options.forEach(function (btn) {
        btn.addEventListener('click', function () {
          options.forEach(function (o) { o.classList.remove('is-active'); });
          btn.classList.add('is-active');

          var selectedOption = btn.dataset.subOption;
          var form = btn.closest('form') || document.querySelector('form[action*="cart"]');
          if (!form) return;

          // Show/hide the relevant price display elements
          var allPrices = form.querySelectorAll('[data-price-option]');
          allPrices.forEach(function (el) {
            el.style.display = el.dataset.priceOption === selectedOption ? '' : 'none';
          });
        });
      });
    });
  })();

});
